var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"user-search"}},[_c('search-form',{attrs:{"legend":"Users","label":_vm.label,"pageRef":_vm.$parent,"searchUrl":_vm.searchUrl,"filterByFeatured":_vm.filterByFeatured,"filterByStaff":_vm.filterByStaff}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d44cc0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserSearch.vue
// module id = 1221
// module chunks = 1